import { useContext, createContext } from 'react';

const NuiContext = /*#__PURE__*/createContext({});

// For internal use only
const useNuiContext = () => useContext(NuiContext);

export { NuiContext, useNuiContext };
